export default __webpack_public_path__ + "static/9-31acb52944d83c856e1420429156f0c2.png";